import { pdkAxios } from '@/lib/pdk-axios';
import type { VehicleImageCategory } from '@/models/types';

export async function fetchAvailableVehicleImageCategories(): Promise<
  VehicleImageCategory[]
> {
  try {
    const response = await pdkAxios.get<VehicleImageCategory[]>(
      '/inventory/image-category/all',
    );

    return response.data;
  } catch (err) {
    throw err;
  }
}
